// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-n_fx","advertDetailContacts__header":"c-n_fy"};